// import React from "react";

// export default function uploadFile() {
//   return (
//     <div>
//       <form
//         action="http://localhost:3977/api/v1/subir-file"
//         method="POST"
//         encType="multipart/form-data"
//       >
//         <input type="file" name="file"></input>

//         <input type="submit" value="Subir"></input>
//       </form>
//     </div>
//   );
// }

import { InboxOutlined } from "@ant-design/icons";
import { message, Upload, Button } from "antd";
import React, { useState, useEffect } from "react";
import "./uploadFile.scss";
import { getAccessTokenApi,getRefreshTokenApi,getPublicIP, getKeyrockTokenApi } from "../../api/auth";
import { basePath, apiVersion } from "./../../api/config";

const { Dragger } = Upload;

const props = {
  name: "file",
  multiple: false,
  action: `${basePath}/${apiVersion}/subir-file`,
  //action: "http://localhost:3977/api/v1/subir-file",

  headers: {
    /* Authorization: getAccessTokenApi(),
    keyrockAuth: getKeyrockTokenApi(), */
    Authorization: "Bearer " + getAccessTokenApi(),
    refreshToken: "Bearer " + getRefreshTokenApi(),
    functionname:'getAltitude',
    keyrockAuth: getKeyrockTokenApi(),
    ippublica:getPublicIP()
  },
  
  onChange(info) {
    
    const { status } = info.file;
    if (status !== "uploading") {
     //console.log(info.file, info.fileList);
     //console.log('uploading')
    }
    if (status === "done") {
      //console.log('done')
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      //console.log('error')
      message.error(`${info.file.name} file upload failed.`);
    }
  },
  onDrop(e) {
  // console.log("Dropped files", e.dataTransfer.files);
  },
  // beforeUpload: (file) => {
  //   return true;
  // },
     beforeUpload: (file) => {
      console.log('tamaño: ',file)
      console.log('tamaño cosas: ',file.size)
      const fileSize = file.size / 1024 / 1024; // Convert file size to MB
      if (fileSize > 1) {
        message.error('File size should be less than 1MB.');
        return false;
      }
      return true;
    }
};

export default function uploadFile() {
  return (
    <div>
      <h1>
        Drag one scenario in the "Drag and Drop area" to be run by the
        simulator:{" "}
      </h1>
      <Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single or bulk upload. Strictly prohibit from uploading
          company data or other band files
        </p>
      </Dragger>
      <div className="divClass">
        {/* <Button type="primary" htmlType="submit" className="btn-submit">
          Enviar
        </Button> */}
      </div>
    </div>
  );
}

// import { Upload, message } from 'antd';
// import { InboxOutlined } from '@ant-design/icons';

// const { Dragger } = Upload;

// const App = () => {
//   const handleFileUpload = (info) => {
//     const { status, response } = info.file;
//     if (status === 'done') {
//       message.success(`${info.file.name} uploaded successfully.`);
//     } else if (status === 'error') {
//       message.error(`${info.file.name} upload failed.`);
//     }
//   };

//   const beforeUpload = (file) => {
//     const fileSize = file.size / 1024 / 1024; // Convert file size to MB
//     if (fileSize > 1) {
//       message.error('File size should be less than 1MB.');
//       return false;
//     }
//     return true;
//   };

//   return (
//     <div>
//       <Dragger
//         name="file"
//         action="/upload"
//         beforeUpload={beforeUpload}
//         onChange={handleFileUpload}
//       >
//         <p className="ant-upload-drag-icon">
//           <InboxOutlined />
//         </p>
//         <p className="ant-upload-text">Click or drag file to this area to upload</p>
//         <p className="ant-upload-hint">Support for a single file with a size limit of 1MB.</p>
//       </Dragger>
//     </div>
//   );
// };

